import React from 'react'
import { FiArrowLeftCircle } from 'react-icons/fi'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import NotFoundImage from '../assets/404.avif' 

const NotFound = () => {
  return (
    <div className="min-h-screen flex flex-col bg-white text-gray-800">
      <Navbar />

      <div className="flex-grow flex items-center justify-center px-4 py-12 mt-24">
        <div className="max-w-2xl text-center">
          <img
            src={NotFoundImage}
            alt="404 Not Found"
            className="w-full max-w-md mx-auto mb-8"
          />

          <h1 className="text-4xl md:text-5xl font-bold text-[#003A7D] mb-4">Page Not Found</h1>
          <p className="text-lg md:text-xl text-gray-600 mb-6">
            Sorry, the page you're looking for doesn't exist or has been moved.
          </p>

          <a
            href="/"
            className="inline-flex items-center gap-2 px-6 py-3 bg-[#003A7D] text-white rounded-lg shadow hover:bg-[#002d63] transition"
          >
            <FiArrowLeftCircle className="text-xl" />
            Back to Home
          </a>
        </div>
      </div>

      <Footer />
    </div>
  )
}

export default NotFound